<div class="widget-title">Amount Spent</div>
<div class="chartContainer">
    <div *ngIf="!noData" [innerHTML]="totalSpentContent" class="amountSpentTotal"></div>
    <div *ngIf="!noData" [innerHTML]="curPurchaseContent" class="curPurchase"></div>
    <div *ngIf="!noData" [innerHTML]="footerContent" class="footer"></div>
    <div *ngIf="noData" class="noData pad">No Data Available</div>
</div>